
import TitleBox from '@/components/CSS/TitleBox'
// import { articleDetail, companyList } from "@/api/common";
const recruit = () => import('@/components/recruit/index')

export default {
	components: {
		TitleBox,
		recruit
	},
	head() {
		return {
			title: '企业介绍',
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content:
						'盼之网络科技有限公司成立于2017年，是一家专业的游戏交易平台服务商、致力于为客户提供专业、安全、高效的用户体验。始终以“安全”“信任”作为产品和服务的核心，坚持经营理念：使账号交易变得更安全！'
				}
			]
		}
	},
	data() {
		return {
			loading: null,
			navIndexTitle: null,
			navIndex: null,
			navList: [],
			viewer: {},
			articleContent: {
				content: null,
				createTime: null,
				id: null,
				title: null
			},
			routeTitle: null
		}
	},
	filters: {
		get_chinese(num) {
			switch (num) {
				case 1:
					return '一'
				case 2:
					return '二'
				case 3:
					return '三'
				case 4:
					return '四'
				case 5:
					return '五'
				case 6:
					return '六'
				case 7:
					return '七'
				case 8:
					return '八'
				case 9:
					return '九'
				default:
					return num
			}
		}
	},
	watch: {
		$route: {
			handler: function (route) {
				this.routeTitle = route.params.title
				if (this.routeTitle) this.getNavList()
			},
			immediate: true
		}
	},
	created() {
		if (!this.routeTitle) this.getNavList()
	},
	methods: {
		navHandler(item) {
			if (this.$route.params.title === item.title) return
			this.$router.push(`/qyjs/${item.title}`)
		},
		getNavList() {
			this.$api.companyList().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.navList = res.data
				this.navIndexTitle = this.routeTitle ? this.routeTitle : res.data[0].title // 选中第一个
				this.navIndex = res.data[0].id // 选中第一个
				this.getArticle()
			})
		},
		getArticle() {
			this.loading = true
			let p = {
				action: {
					title: this.navIndexTitle
				}
			}
			this.$api.articleDetail(p).then(res => {
				this.loading = false
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.articleContent = res.data
			})
		}
	}
}
